"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var filter_1 = require("./libraries/filter");
function bestPricePerRegion(state) {
    return function (routeId) {
        var filtered = filteredOffers(state)(routeId);
        var filteredOk = filtered && filtered.length > 0;
        var orderedOffers = _.orderBy(filtered, function (cruise) { return cruise.cheapestPrice; });
        return filteredOk ? orderedOffers[0].cheapestPrice : 0;
    };
}
exports.bestPricePerRegion = bestPricePerRegion;
function carolCampaign(state) {
    return state.carolCampaign;
}
exports.carolCampaign = carolCampaign;
function durationBestPricePerRegion(state) {
    return function (routeId) {
        var filtered = filteredOffers(state)(routeId);
        var filteredOk = filtered && filtered.length > 0;
        var orderedOffers = _.orderBy(filtered, function (cruise) { return cruise.cheapestPrice; });
        return filteredOk ? orderedOffers[0].duration : 0;
    };
}
exports.durationBestPricePerRegion = durationBestPricePerRegion;
function durations(state) {
    return _.sortBy(state.availableDurations, 'id');
}
exports.durations = durations;
function filteredOffers(state) {
    return function (routeId) {
        var filteredResults = filter_1.Filter.filterByRoute(state.teaserOffers, routeId);
        return filteredResults;
    };
}
exports.filteredOffers = filteredOffers;
function filters(state) {
    return state.filter;
}
exports.filters = filters;
function numberOffers(state) {
    return state.teaserOffers.length;
}
exports.numberOffers = numberOffers;
function offers(state) {
    return state.teaserOffers;
}
exports.offers = offers;
function priceModel(state) {
    return state.priceModel;
}
exports.priceModel = priceModel;
function pricePlanCodes(state) {
    return state.pricePlanCodes;
}
exports.pricePlanCodes = pricePlanCodes;
function reducedOffers(state) {
    return state.teaserOffersReduced;
}
exports.reducedOffers = reducedOffers;
function selectedTravelDuration(state) {
    var durationsArray = durations(state);
    var duration = _.find(durationsArray, {
        id: state.filter.travelDuration,
    });
    if (duration) {
        return duration;
    }
    return {
        from: 1,
        id: 0,
        name: 'Reisedauer',
        shortName: 'Dauer',
        to: 9999,
    };
}
exports.selectedTravelDuration = selectedTravelDuration;
function stateGetter(state) {
    return state;
}
exports.stateGetter = stateGetter;
function timeStamp(state) {
    return state.timeStamp;
}
exports.timeStamp = timeStamp;
function timingStates(state) {
    return state.timingStates;
}
exports.timingStates = timingStates;
//# sourceMappingURL=getters.js.map